import { Component, Inject, OnInit } from '@angular/core';
import { HTTPStatus } from 'src/app/CommonService/app-token-handler';
import { DataService } from 'src/app/CommonService/data.service';
import { CommonService } from 'src/app/Shared/common.service';
import saveAs from 'file-saver'
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpEvent } from '@angular/common/http';

export interface DialogData {
  Attachment: any;
  Count: any;
  fieldName: string;
  BlobId: string;
    BlobIds: string[];
  filefordelete: string;
  IsFormEditable: boolean;
  ModuleName: string;
  ApprovalStatus: number;
  CanAttachAfterSubmit: boolean;
  IsAttachmentEnable: boolean;
  ScreenName :string;
}

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent implements OnInit {

  AttachmentsGroup: any;
  file!: File;
  formData: FormData = new FormData();
  LocalAttachments: any;
  stringArray: any;
  IsLoadingResults:boolean = false; 
  IsApproved: boolean;
  IsAttachmentEnable!: boolean;

  constructor(public dialogRef: MatDialogRef<FileUploadComponent>,
      private _commonService: CommonService, private _dataService: DataService,
      @Inject(MAT_DIALOG_DATA) public _data: DialogData, private status: HTTPStatus) {
      this.IsApproved = false;
  }

  ngOnInit() {
      this.IsAttachmentEnable = (this._data.IsAttachmentEnable === true) ? true : false;



      this.IsApproved = false;
      this.AttachmentsGroup = [];
      this.stringArray = [];
      if (this._data.Count > 0) {
          this.LocalAttachments = [];
          this._data.Attachment.forEach((entry: string, index: number) => {
              const fileExtension = entry.substring(entry.lastIndexOf('.') + 1);
              this.stringArray = entry.split('_');
              const newName = this.stringArray.slice(2).join('_');
              let newFileName = '';
              if (newName.lastIndexOf('_') === -1) {
                  newFileName = newName;
              } else {
                  newFileName = newName; // .substring(0, newName.lastIndexOf('_')) + '.' + fileExtension;
              }

              const blobId = this._data.BlobIds?.[index] ?? this._data.BlobId;
              this.LocalAttachments.push({ 'File': newFileName, 'FullName': entry , 'BlobId': blobId});
          });
      } else {
          this.LocalAttachments = [];
          this._data.Attachment = [];
      }
  }

  onNoClick(): void {
      this.dialogRef.close();
  }

  UploadAttachment(event:any) {

      if (event.target.files.length > 0) {
        this.IsLoadingResults = true;
          const fileList: FileList = event.target.files;
          const file: File = fileList[0];
          const maxLength = 1024 * 1024 * 10;
          const maxLengthForClause = 1024 * 1024 * 2;
          const maxLengthForTQApprover = 1024 * 1024 * 5;
          const fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
          
          // For TQApproverAttachment: only allow PDF, PNG, JPEG, JPG, Word, Excel, mail, zip
          if(this._data.ScreenName === "TQApproverAttachment"){
              if (!(fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'png'
                  || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'jpg'
                  || fileExtension.toLowerCase() === 'doc' || fileExtension.toLowerCase() === 'docx'
                  || fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'xlsx'
                  || fileExtension.toLowerCase() === 'msg' || fileExtension.toLowerCase() === 'zip')) {
                  this.IsLoadingResults = false;
                  alert('Please browse valid file extension. Allowed: PDF, PNG, JPEG, JPG, Word, Excel, Mail, ZIP');
                  event.target.value = '';
                  return;
              }
              if (event.target.files[0].size > maxLengthForTQApprover) {
                  this.IsLoadingResults = false;
                  alert('File size can not be more than 5 mb.');
                  event.target.value = '';
                  return;
              }
              this.formData = new FormData();
              this.formData.append('Attachments', file, file.name);
              this.status.setHttpStatus(true);
              this._dataService.postfile('Attachment/UploadAttachment/' + 'Attachments', this.formData).subscribe((path:any) => {
                  if (path['RequestIsSuccess']) {
                      this.LocalAttachments.push({ 'File': file.name, 'FullName': path['RequestMessage'] , 'BlobId': path['BlobId']});
                      this._data.Attachment.push(path['RequestMessage']);
                      this._data.BlobId = path['BlobId'];
                  } else {
                      alert(path['RequestMessage']);
                  }
              },
                  (error) => { this.status.setHttpStatus(false);  
                    this.IsLoadingResults = false;
                  },
                  () => { this.status.setHttpStatus(false); 
                    this.IsLoadingResults = false;
                  });
          }
          else if (fileExtension.toLowerCase() === 'docx' || fileExtension.toLowerCase() === 'doc'
              || fileExtension.toLowerCase() === 'pdf' || fileExtension.toLowerCase() === 'zip'
              || fileExtension.toLowerCase() === 'xls' || fileExtension.toLowerCase() === 'xlsx' || fileExtension.toLowerCase() === 'jpg'
              || fileExtension.toLowerCase() === 'jpeg' || fileExtension.toLowerCase() === 'png'
              || fileExtension.toLowerCase() === 'msg') {
              this.formData = new FormData();
              if(this._data.ScreenName === "AddClauseAttachment"){
                
                if (event.target.files[0].size > maxLengthForClause) {
                     this.IsLoadingResults = false;

                    alert('File size can not be more than 2 mb.');
                    event.target.value = '';
                    return;
                }
              }
              else{
                if (event.target.files[0].size > maxLength) {
                   this.IsLoadingResults = false;

                    alert('File size can not be more than 10 mb.');
                    event.target.value = '';
                    return;
                }
              }
           
              this.formData.append('Attachments', file, file.name);
              this.status.setHttpStatus(true);
              this._dataService.postfile('Attachment/UploadAttachment/' + 'Attachments', this.formData).subscribe((path:any) => {
                  if (path['RequestIsSuccess']) {
                      this.LocalAttachments.push({ 'File': file.name, 'FullName': path['RequestMessage'] , 'BlobId': path['BlobId']});
                      this._data.Attachment.push(path['RequestMessage']);
                      this._data.BlobId = path['BlobId'];
                  } else {
                      alert(path['RequestMessage']);
                  }
                  
              },
                  (error) => { this.status.setHttpStatus(false);  
        this.IsLoadingResults = false;
                  },
                  () => { this.status.setHttpStatus(false); 
        this.IsLoadingResults = false;



                  });
          } else {
              alert('Please browse valid file extension.');
        this.IsLoadingResults = false;

              event.target.value = '';
          }
      }
  }

  DeleteAttachment(attachmentName: string) {
      if (confirm('Are you sure?')) {
          this.stringArray = attachmentName.split('_');
          const attachmentID = this.stringArray.slice(0, 1).join('_');
          if (attachmentID !== '0') {
              this._dataService.get('Attachment/DeleteAttachment/'+ attachmentID +  '/' + 'File').subscribe((x:any) => {
                alert(x['RequestMessage']);

                if(x['RequestIsSuccess']){
                    this.LocalAttachments = this.LocalAttachments.filter((res: { FullName: string; }) => res.FullName !== attachmentName);
                    this._data.Attachment = this._data.Attachment.filter((res: string) => res !== attachmentName);
  
                }
                              }, (error:any) => {
                  this.status.setHttpStatus(false);
              });
          } else {
              this.LocalAttachments = this.LocalAttachments.filter((x: { FullName: string; }) => x.FullName !== attachmentName);
              this._data.Attachment = this._data.Attachment.filter((x: string) => x !== attachmentName);
          }
      }
  }

  DownloadFile(BlobId: string, fileName: string) {
      // const attachmentID = attachmentName.substring(0, 4);
      if(BlobId === '' || BlobId === null || BlobId === undefined){
        return;
      }
      const downloadURL = 'Attachment/DownloadAllAttachmentByName';
      const attachment = { AttachmentName: BlobId, ScreenName: '' };
      this._dataService.PostDownload(downloadURL, attachment).subscribe((x:any) => {
          const blob = new Blob([x], { type: 'application/octet-stream' });
          saveAs(blob, fileName);
      },
      (error:any)=>{
        console.log(error);
        ////this.alertService.notify('error','Error!',error.error.Message);
      });
  }
}


